import React, { Component } from "react";
import BudgetTable from "../../BudgetTable";

import colors from "../../colors";
// import menu from "../data/data";//menu
import Slider from "./Slider";
import MediaQuery from "react-responsive";

const budget = {
  header: [
    "2016-2017",
    "2017-2018",
    "2018-2019",
    "2019-2020",
    "2020-2021",
    "2021-2022",
    "2022-2023",
    "2023-2024",
  ],
  rows: {
    row1: [
      "Satellite Data",
      "0.0",
      "3.0",
      "3.0",
      "3.0",
      "3.0",
      "3.0",
      "2.0",
      "2.0",
      "19.0",
    ],
    row2: [
      "Field Experimentation & OutSoursing Activities",
      "0.0",
      "5.0",
      "250.0",
      "250.0",
      "50.0",
      "50.0",
      "50.0",
      "50.0",
      "705.0",
    ],
    row3: [
      "NRSC Manpower",
      "1.6",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "37.0",
    ],
    row4: [
      "Project Scientists",
      "0.0",
      "18.5",
      "18.5",
      "18.5",
      "18.5",
      "18.5",
      "18.5",
      "18.5",
      "129.8",
    ],
    row5: [
      "Data Analysis",
      "2.0",
      "5.0",
      "5.0",
      "5.0",
      "3.0",
      "3.0",
      "3.0",
      "3.0",
      "29.0",
    ],
    row6: [
      "Hardware & Software + Maintenance",
      "12.0",
      "16.0",
      "1.0",
      "3.0",
      "3.0",
      "3.0",
      "3.0",
      "3.0",
      "43.8",
    ],
    row7: [
      "ALTM DEM / High Resolution Satellite DEM Generation",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row8: [
      "Travel & Field Works",
      "1.0",
      "6.0",
      "6.0",
      "6.0",
      "6.0",
      "3.0",
      "3.0",
      "3.0",
      "34.0",
    ],
    row9: [
      "Training & Workshops",
      "0.0",
      "5.0",
      "12.0",
      "12.0",
      "10.0",
      "2.0",
      "2.0",
      "2.0",
      "45.0",
    ],
    row10: [
      "Sub - Total 1",
      "16.6",
      "63.6",
      "300.6",
      "302.6",
      "98.6",
      "87.6",
      "86.6",
      "86.6",
      "1042.6",
    ],
    row11: [
      "Project Management @ 5% of Sub - Total 1",
      "0.8",
      "3.2",
      "15.0",
      "15.1",
      "4.9",
      "4.4",
      "4.3",
      "4.3",
      "52.1",
    ],
    row12: [
      "Sub - Total 2",
      "17.5",
      "66.8",
      "315.6",
      "317.7",
      "103.5",
      "91.9",
      "90.9",
      "90.9",
      "1094.7",
    ],
    row13: [
      "Organization Overheads @ 5% of Sub - Total 2",
      "0.9",
      "3.3",
      "15.8",
      "15.9",
      "5.2",
      "4.6",
      "4.5",
      "4.5",
      "54.7",
    ],
    row14: [
      "Grand Total",
      "18.3",
      "70.1",
      "331.4",
      "333.6",
      "108.7",
      "96.5",
      "95.4",
      "95.4",
      "1149.4",
    ],
  },
};

export default class ETProjTeam extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
          height: "800px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />
          {/* <MDBCard style={{ width: "100%", }}>
            <MDBCardBody> */}
          <div className="card" style={{ flexGrow: "1", overflowX: "auto" }}>
            <MediaQuery minWidth={991}>
              <div
                className="card-body"
                style={{ margin: "auto", padding: "10px" }}
              >
                <h3 align="center" style={{ color: "#002171" }}>
                  Regional Evaporative Flux Monitoring System
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
            <MediaQuery maxWidth={991}>
              <div className="card-body" style={{ padding: "10px" }}>
                <h3 align="center" style={{ color: "#002171" }}>
                  Regional Evaporative Flux Monitoring System
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
          </div>
        </div>
      </div>
    );
  }
}
